/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Watchpage_Meta_DescInputs */

const en_fw_watchpage_meta_desc = /** @type {(inputs: Fw_Watchpage_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch the Firefly Wedding anime on Crunchyroll, Fuji TV Noitamina, AT-X and Japanese streaming services. Full 2026 episode schedule with JST air times.`)
};

const zh_fw_watchpage_meta_desc = /** @type {(inputs: Fw_Watchpage_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画观看指南：Crunchyroll、富士电视台ノイタミナ、AT-X 与日本各流媒体平台，附 2026 年完整播出时间表（日本时间）。`)
};

/**
* | output |
* | --- |
* | "Watch the Firefly Wedding anime on Crunchyroll, Fuji TV Noitamina, AT-X and Japanese streaming services. Full 2026 episode schedule with JST air times." |
*
* @param {Fw_Watchpage_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_watchpage_meta_desc = /** @type {((inputs?: Fw_Watchpage_Meta_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Watchpage_Meta_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_watchpage_meta_desc(inputs)
	return zh_fw_watchpage_meta_desc(inputs)
});
export { fw_watchpage_meta_desc as "fw.watchpage.meta_desc" }